import { forwardRef, memo, Ref, useImperativeHandle, useRef, useState } from 'react';
import { useAzureProvider } from 'src/azure/context';
import {
	Breadcrumb,
	BreadcrumbButton,
	BreadcrumbDivider,
	BreadcrumbItem,
	Button,
	Dialog,
	DialogSurface,
	makeStyles,
	tokens,
} from '@fluentui/react-components';
import { Dismiss16Regular } from '@fluentui/react-icons';
import { AuthorizationSteps } from '.';

interface AuthorizationStepsWithModalProps {
  onClose?: () => void;
}

interface AuthorizationStepsWithModalRef {
  open: () => void;
  close: () => void;
}

export const useAuthorizationStepsWithModalRef = () => useRef<AuthorizationStepsWithModalRef>(null);

function AuthorizationStepsWithModalRef(props: AuthorizationStepsWithModalProps, ref: Ref<AuthorizationStepsWithModalRef>) {
	const classes = useStyles();
	const {applicationContext} = useAzureProvider();

	const [open, setOpen] = useState(false);

	useImperativeHandle(ref, () => ({
		open: () => setOpen(true),
		close: () => setOpen(false),
	}));

	return (
		<Dialog modalType="non-modal" open={open}>
			<DialogSurface style={{ width: '100%', maxWidth: '100%', height: '100vh', margin: 0, overflowY: 'scroll', backgroundColor: tokens.colorNeutralBackground2 }}>
				<div className={classes.header}>
					<Breadcrumb aria-label="Breadcrumb default example">
						<BreadcrumbItem>
							<BreadcrumbButton onClick={() => {
								props.onClose?.();
								setOpen(false);
							}}>
								Appgami Automation
							</BreadcrumbButton>
						</BreadcrumbItem>
						<BreadcrumbDivider />
						<BreadcrumbItem>
							<BreadcrumbButton disabled current>Finish setup</BreadcrumbButton>
						</BreadcrumbItem>
					</Breadcrumb>
					<Button
						appearance='transparent'
						onClick={() => {
							props.onClose?.();
							setOpen(false);
						}}>
						<Dismiss16Regular />
					</Button>
				</div>
				<AuthorizationSteps
					onClose={() => {
						props.onClose?.();
						setOpen(false);
					}}
					organizationName={applicationContext.organizationName}
					organizationId={applicationContext.organizationId}
				/>
			</DialogSurface>
		</Dialog>
	);
}

const useStyles = makeStyles({
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '16px',
	}
});

const AuthorizationStepsWithModal = AuthorizationStepsWithModalRef;
export default memo(forwardRef(AuthorizationStepsWithModal));